import { defineStore } from 'pinia';
import { Translations } from 'vue3-gettext';
import gettext from './gettext';

const languages = import.meta.glob('./language/*.json', { eager: false });

type Language = 'en' | 'fr';

type LanguageState = {
  translations: Translations;
  forceLanguage?: Language;
  current?: Language;
};

export const useLanguageStore = defineStore('language', {
  state: (): LanguageState => ({
    translations: {},
  }),

  actions: {
    async loadLanguage(lang: Language) {
      const translations = (await languages[`./language/${lang}.json`]()).default as Translations;

      this.translations[lang] = translations[lang];
      gettext.translations = this.translations;
    },

    async setLanguage(lang: string, force: boolean = false) {
      const locale = lang.split('-')[0] as Language;

      if (force) {
        this.forceLanguage = locale;
      }

      if (typeof this.forceLanguage !== 'undefined' && locale !== this.forceLanguage) {
        console.warn(`You're trying to set language to ${lang} but it's forced to ${this.forceLanguage}`);
        return;
      }

      if (typeof this.translations[locale] === 'undefined' || typeof gettext.translations[locale] === 'undefined') {
        await this.loadLanguage(locale);
      }
      gettext.current = locale;
      this.current = locale;
    },
  },
});
